import React, { use, useEffect, useState } from 'react'
import styles from "../Corpus/corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import "../../App.css"
import CustomSelect from '../../Components/CustomSelect'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import UnitStyles from "../MilUnit/MilUnit.module.css"
import 'react-toastify/dist/ReactToastify.css'
import MillUnitList from '../../Components/MilUnitList'

export default function Platoon() {
    const [platoon, setPlatoon] = useState("")
    const [platoons, setPlatoons] = useState([])
    const [battalions, setBattalions] = useState([])
    const [companies, setCompanies] = useState([])
    const [milUnits, setMilUnits] = useState([])
    const [mil, setMil] = useState("")
    const [change, setChange] = useState(null)
    const [bat, setBat] = useState('')
    const [company, setCompany] = useState('')
    const [loading, setLoading] = useState(false)
    const [clear, setClear] = useState(false)
    const [corpuses, setCorpuses] = useState([])
    const [corpusNum, setCorpusNum] = useState()
    const [isMillUnitShown, setMillUNitShown] = useState(false)
    const [search, setSearch] = useState("")

    useEffect(() => {
            (async() => {
                const corpuses = await axiosInstance.get('admin/corpuses')
                if(corpuses.status){
                    setCorpuses(corpuses.data.data)

                }
            })()
        }, [])

    useEffect(() => {
        (async() => {
            const milunits = await axiosInstance.get('admin/milunits')
            if(milunits.status){
                setMilUnits(milunits.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        (async() => {
            const platoons = await axiosInstance.get(`admin/platoon`)
            if(platoons.status){
             setPlatoons(platoons.data.data)
            }
        })()
    }, [])
    useEffect(() => {
        (async() => {
            const batalions = await axiosInstance.get(`admin/battalions/${mil}`)
            if(batalions.status){
                setBattalions(batalions.data.data)
                
            }
        })()
        }, [mil])
    useEffect(() => {
        if(battalions){
            const filtered = battalions.filter(el => el._id === bat)
            const [obj] = filtered
            const unique = [... new Set(obj?.battalion_company)]
            setCompanies(unique)
        }
    },[bat])

    const submitHandler = async () => {
        if(!platoon){
            toast.error("Դասակի համար/անվանում դաշտը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.post('admin/platoon', {platoon_number: platoon, platoon_unit: mil ? mil : null, platoon_battalion: bat ? bat : null, platoon_company: company ? company : null})
        if(res.data.status){
            setMil("")
            setPlatoon("")
            setBat("")
            setCompany("")
            setPlatoons([...platoons, res.data.data])
            toast.success("Դասակը հաջողությամբ ավելացվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }
    const chnageCompany = async (el) => {
        setChange(el)
        setPlatoon(el.platoon_number ? el.platoon_number : '')
        setMil(el.platoon_unit)
        setBat(el.platoon_battalion)
        setCompany(el.platoon_company)
    }

    const deleteCompany = async (el) => {
        const res = await axiosInstance.delete(`admin/platoon/${el._id}`)
        if(res.data.status){
            setPlatoons(p => p.filter(c => c._id !== el._id))
            toast.success("Դասակը հաջողությամբ ջնջվեց");
        }
    }   
    const changeHandler = async () => {
        if(!platoon){
            toast.error("Դասակի համար/անվանում դաշտը պարտադիր է");
            return;
        }   
        setLoading(true)
        const res = await axiosInstance.put(`admin/platoon/${change._id}`, {platoon_number: platoon, platoon_unit: mil ? mil : null, platoon_battalion: bat ? bat : null, platoon_company: company ? company : null})
        if(res.status){
            setChange(null)
            setPlatoons(p => {
                    let index = platoons.findIndex(el => el._id === change._id)
                    const newPlatoons = [...platoons]
                    newPlatoons[index] = {...res.data.data}
                    return newPlatoons
                })
                setPlatoon("")
                setMil("")
                setBat("")
                setCompany("")
                toast.success("Դասակը հաջողությամբ փոփոխվեց");
                setClear(true)
                setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

  return (
    <div className={styles["corpus-main-div"]}>
        <div className={styles["corpus-container"]}>
            <h2>Լրացրեք վաշտի տվյալները</h2>
             <div>
                <label htmlFor="platoonNumber">Դասակի համար/անվանում</label>
                <input type="text" id="platoonNumber" value={platoon} onChange={(e) => setPlatoon(e.target.value)} />
            </div>
            <div>
                <CustomSelect 
                    defaultValueForInput={mil ? mil.unit_number : ''}
                    options={milUnits?.map((el,i) => <option key={i} value={el._id}>{el.unit_number}</option>)}
                    callback={setMil}
                    label="Ընտրել զորամասը"
                    clear={clear}
                />
            </div>
            <div className='my-[20px]'>
                <CustomSelect 
                    defaultValueForInput={bat ? bat.battalion_number : ''}
                    options= {battalions?.map((el,i) => <option key={i} value={el._id}>{el.battalion_number}</option>)}
                    callback={setBat}
                    label="Ընտրել գումարտակը"
                    clear={clear}
                />
            </div>
            <div className='mb-[20px]'>
                <CustomSelect 
                    defaultValueForInput={company ? company.company_number : ''}
                    options= {companies?.map((el,i) => <option key={i} value={el._id}>{el.company_number}</option>)}
                    callback={setCompany}
                    label="Ընտրել վաշտը"
                    clear={clear}
                />
            </div>
           
            <button className={`confirm-btn`} disabled={loading} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
        </div>
        <div className={styles["corpus-list"]}>
            <div className='relative'>
                <h2>Դասակներ</h2>
                <input type="text" placeholder='Փնտրել...' className="absolute border border-black/40 p-1 rounded-md top-0 left-4" onChange={(e) => setSearch(e.target.value)}/>
            </div>
            {!search ? corpuses.map((el, index) => {
                return (
                    <li key={index} className={UnitStyles["corpus-list-items"]}>
                        <p className='text-center cursor-pointer' onClick={() => {setCorpusNum(el._id);setMillUNitShown(!isMillUnitShown)}}>{el?.corpus_number + " " + el?.corpus_name}</p>
                        {isMillUnitShown && corpusNum === el._id  && <MillUnitList millUnits={milUnits} corpusNumber={el?._id} platoons={platoons} changeMilUnit={chnageCompany} deleteBattalion={deleteCompany} />}
                    </li>
                )
             }) :         <ol onClick={e => e.stopPropagation()}>
                         <li className={styles["corpus-list-item"]}>
                             <p className='per5 start'>Դասակի համար</p>
                             <p className='per5'>Զորամաս</p>
                             <p className='per5'>Գումարտակ</p>
                             <p className='per5'>Վաշտ</p>
                             <p className='per5 end'>Ղեկավարման կոճակներ</p>
                         </li>
                         {platoons?.filter(el => el?.platoon_number?.includes(search)).map((el, index) => {
                             return <li key={index} className={styles["corpus-list-item"]}>
                                    <p className='per5 start'>{el?.platoon_number}</p>
                                    <p className='per5'>{el?.platoon_unit ? el?.platoon_unit.unit_number : ""}</p>
                                    <p className='per5'>{el?.platoon_battalion ? el?.platoon_battalion.battalion_number : ""}</p>
                                    <p className='per5'>{el?.platoon_company ? el?.platoon_company.company_number : ""}</p>
                                     <div className='per5 end flex justify-end'>
                                         <button className={`btn cursor-pointer`} onClick={() => chnageCompany(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                         <button className={`btn cursor-pointer`} onClick={() => deleteCompany(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                                     </div>
                                 </li>
                         })}
                     </ol>}
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
